<template>
  <transition name="search-popup">
    <div class="modal-mask" @click.self.prevent="showView(statusView)">
      <div class="modal-wrapper">
        <button type="button" class="popup-close" @click="closeSearchPopup()"><img src="../../assets/images/common/btn-popup-close.png" alt=""/></button>
        <!-- 검색어 검색 -->
        <template v-if="(statusView !== 'tagDetail' && statusView !== 'reTagDetail_broadcast' && statusView !== 'reTagDetail_movie')">
          <search-popup-text :statusView="statusView" :showView="showView" />
        </template>
        <!-- // 검색어 검색 -->

        <!-- 태그 검색 -->
        <template v-else>
          <search-popup-tag :statusView="statusView" :showView="showView" :isplayymovie="isplayymovie" />
        </template>
        <!-- // 태그 검색 -->
      </div>
    </div>
  </transition>
</template>

<script>
import SearchPopupText from '@/components/search/SearchPopupText'
import SearchPopupTag from '@/components/search/SearchPopupTag'
import { CLOSE_SEARCH_POPUP_EVENT } from '@/common/resources/const'

export default {
  components: {
    SearchPopupText, // 검색어 검색
    SearchPopupTag // 태그 검색
  },
  props: {
    closeSearchPopup: {
      type: Function
    },
    pageType: {
      type: String
    },
    isplayymovie: {
      type: String,
      default: 'y'
    }
  },
  data () {
    return {
      statusView: 'popul' // 화면 출력여부 (popul: 인기, realTime: 실시간검색, history: 최근, detail: 일반검색결과, tagDetail: 태그검색결과)
    }
  },
  methods: {
    showView (val, word) {
      if (val === 'main') {
        if (word) {
          this.statusView = 'realTime'
        } else {
          this.statusView = 'popul'
        }
      } else if (val === 'history') {
        if (word) {
          this.statusView = 'realTime'
        } else {
          this.statusView = 'history'
        }
      } else {
        this.statusView = val
      }
    }
  },
  created () {
    this.$events.$on(CLOSE_SEARCH_POPUP_EVENT, () => {
      this.closeSearchPopup()
    })
    this.statusView = 'popul'
    if (this.pageType !== '') {
      this.statusView = this.pageType
    }
  },
  beforeDestroy () {
    this.$events.$off(CLOSE_SEARCH_POPUP_EVENT)
  }
}
</script>
<style lang="css" src="@/assets/css/search.css"></style>
<style>
.sh-pop-body{
  padding-top: 103px;
  overflow: hidden;
}
.search-popup-enter-active, .search-popup-leave-active {
  transition: opacity .3s
}
.search-popup-enter, .search-popup-leave-to { /* .fade-leave-active below version 2.1.8 */
  opacity: 0
}
</style>
